import ITTIModel from '../../ittijs/ITTIModel';
export default class extends ITTIModel {
  constructor() {
    super('Utility');
  }
  async getSelectOptions(){
    return await this.fetch('getSelectOptions');
  }
}